import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = {
  class: "card bg-white mb-3",
  style: {"border-radius":"10px"}
}
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  style: {"width":"100%"},
  "aria-hidden": "true"
}
const _hoisted_5 = {
  rowspan: "2",
  style: {"vertical-align":"top"}
}
const _hoisted_6 = { class: "footer" }
const _hoisted_7 = { class: "left-footer-buttons" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertComponent = _resolveComponent("AlertComponent")!
  const _component_DuplicateStyle = _resolveComponent("DuplicateStyle")!
  const _component_StyleComp = _resolveComponent("StyleComp")!
  const _component_ListComponent = _resolveComponent("ListComponent")!
  const _component_NumberOfInput = _resolveComponent("NumberOfInput")!
  const _component_Description = _resolveComponent("Description")!
  const _component_FabricWeight = _resolveComponent("FabricWeight")!
  const _component_TextInputComp = _resolveComponent("TextInputComp")!
  const _component_ReportsPopup = _resolveComponent("ReportsPopup")!
  const _component_OperationListComp = _resolveComponent("OperationListComp")!
  const _component_window = _resolveComponent("window")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isVisibleEdit)
      ? (_openBlock(), _createBlock(_component_window, {
          key: 0,
          ref: "openWindowA",
          title: _ctx.Title,
          stage: 'FULLSCREEN',
          "maximize-button": () => null,
          "restore-button": () => null,
          onClose: _ctx.isFieldsChanged,
          class: "styleWindow",
          style: _normalizeStyle({
        '--status-color': _ctx.operationStatus ? '#08c75e' : _ctx.operationStatus === false ? 'red' : 'transparent'
      })
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.isCancelButtonClicked && _ctx.isSaveEnabled)
                    ? (_openBlock(), _createBlock(_component_AlertComponent, {
                        key: 0,
                        onSetWindow: _ctx.setWindow,
                        isCancelButtonClicked: _ctx.isCancelButtonClicked,
                        onHidePopup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCancelButtonClicked = false))
                      }, null, 8, ["onSetWindow", "isCancelButtonClicked"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_DuplicateStyle, {
                    showPopup: _ctx.showPopup,
                    onVisibleDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPopup = $event)),
                    duplicateStyleId: _ctx.styleId,
                    onDuplicateId: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editStyle($event)))
                  }, null, 8, ["showPopup", "duplicateStyleId"]),
                  _createElementVNode("table", _hoisted_4, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_StyleComp, {
                            class: "col-5",
                            errorMsgStyle: _ctx.errorMsgStyle,
                            remaningLengthStyle: _ctx.styleNameVal.length,
                            maxStyle: _ctx.maxStyle,
                            disableStyle: _ctx.disableStyle,
                            inputStyleName: _ctx.styleNameVal,
                            Title: _ctx.styleName
                          }, null, 8, ["errorMsgStyle", "remaningLengthStyle", "maxStyle", "disableStyle", "inputStyleName", "Title"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ListComponent, {
                            class: "col",
                            onOnChange: _ctx.validateCustomer,
                            error: _ctx.errorMsgCustomer,
                            Data: _ctx.customers,
                            Value: _ctx.customerVal,
                            Title: _ctx.customer
                          }, null, 8, ["onOnChange", "error", "Data", "Value", "Title"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_NumberOfInput, {
                            Title: _ctx.noOfGarments,
                            class: "col-6",
                            onOnChangeVal: _ctx.validateGarmentValue,
                            error: _ctx.errorMsgGarment,
                            Value: _ctx.noOfGarmentsVal
                          }, null, 8, ["Title", "onOnChangeVal", "error", "Value"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_NumberOfInput, {
                            Title: _ctx.noOfProductLine,
                            class: "col-6",
                            onOnChangeVal: _ctx.validateProductionLineValue,
                            error: _ctx.errorMsgProductLine,
                            Value: _ctx.noOfProductLineVal
                          }, null, 8, ["Title", "onOnChangeVal", "error", "Value"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_ListComponent, {
                            Title: _ctx.productCategory,
                            class: "col",
                            onOnChange: _ctx.validateProductCategory,
                            error: _ctx.errorMsgProductCategory,
                            Data: _ctx.productCategoryData,
                            Value: _ctx.productCategoryVal
                          }, null, 8, ["Title", "onOnChange", "error", "Data", "Value"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ListComponent, {
                            Title: _ctx.productType,
                            class: "col",
                            onOnChange: _ctx.validateProductType,
                            error: _ctx.errorMsgProductType,
                            Data: _ctx.productTypeData,
                            Value: _ctx.productTypeVal
                          }, null, 8, ["Title", "onOnChange", "error", "Data", "Value"])
                        ]),
                        _createElementVNode("td", null, [
                          (_ctx.isCalculationEngineLoaded && !_ctx.isV4CalculationEngine)
                            ? (_openBlock(), _createBlock(_component_ListComponent, {
                                key: 0,
                                class: "col",
                                onOnChange: _ctx.setCustomSetting,
                                error: _ctx.errorMsgCustomSetting,
                                Data: _ctx.customSettings,
                                Value: _ctx.settingVal,
                                Title: _ctx.customSetting
                              }, null, 8, ["onOnChange", "error", "Data", "Value", "Title"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_5, [
                          _createVNode(_component_Description, {
                            Title: _ctx.description,
                            class: "col-4",
                            style: {"height":"135px"},
                            showFields: _ctx.showFields,
                            remaningLengthDescription: _ctx.remaningLengthDescription,
                            maxDescription: _ctx.maxDescription,
                            onOnChange: _ctx.setDescriptionValue,
                            description: _ctx.descriptionVal
                          }, null, 8, ["Title", "showFields", "remaningLengthDescription", "maxDescription", "onOnChange", "description"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_FabricWeight, {
                            class: "col",
                            Title: _ctx.fabricWeight,
                            showFields: _ctx.showFields,
                            onOnChange: _ctx.setFabricWeight,
                            weightType: _ctx.fabricWeightVal
                          }, null, 8, ["Title", "showFields", "onOnChange", "weightType"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_TextInputComp, {
                            Title: _ctx.color,
                            class: "col-4",
                            showFields: _ctx.showFields,
                            onOnChange: _ctx.setColorValue,
                            Value: _ctx.colorVal
                          }, null, 8, ["Title", "showFields", "onOnChange", "Value"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_TextInputComp, {
                            Title: _ctx.size,
                            class: "col-4",
                            showFields: _ctx.showFields,
                            onOnChange: _ctx.setSizeValue,
                            Value: _ctx.sizeVal
                          }, null, 8, ["Title", "showFields", "onOnChange", "Value"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      disabled: !_ctx.isSaveEnabled,
                      type: "button",
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitSave && _ctx.onSubmitSave(...args)), ["prevent"])),
                      style: {"width":"92px","border-radius":"5px","background-color":"#0054a6","color":"white"}
                    }, _toDisplayString(_ctx.$t("editStyle.save")), 9, _hoisted_8),
                    _createElementVNode("button", {
                      disabled: _ctx.isSaveEnabled,
                      type: "button",
                      class: "btn btn-sm btn-primary cloneButton",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.showPopup = true), ["prevent"]))
                    }, _toDisplayString(_ctx.$t("styleGrid.colne")), 9, _hoisted_9),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.showReportsPopup = true), ["prevent"])),
                      style: {"width":"auto","border-radius":"5px"},
                      disabled: _ctx.disableReportValue
                    }, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", {
                        class: "fas fa-file-lines",
                        style: {"padding-right":"5px"}
                      }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("styleGrid.reports")), 1)
                    ], 8, _hoisted_10)
                  ])
                ])
              ])
            ]),
            (_ctx.showReportsPopup)
              ? (_openBlock(), _createBlock(_component_ReportsPopup, {
                  key: 0,
                  onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showReportsPopup = false)),
                  noOfGarments: _ctx.noOfGarmentsVal,
                  noOfProductLine: _ctx.noOfProductLineVal,
                  selectedReportPrintingOption: _ctx.selectedReportPrintingOption,
                  onReportFormatChanged: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedReportPrintingOption = $event)),
                  onDownloadSingleGarmentReport: _ctx.handleDownloadSingleGarmentReport,
                  onDownloadSingleGarmentReportWithQuantity: _ctx.handleDownloadSingleGarmentReportWithQuantity,
                  onIsChecked: _ctx.handleIncludeCostElement,
                  onDownloadThreadUsageReport: _ctx.handleDownloadThreadGarmentReport,
                  onNoOfGarments: _ctx.handleNoOfGarmentsForSGC,
                  onNoOfProductionLines: _ctx.handleNoOfProductionLineForTU,
                  loadingGrid: _ctx.loadingGridVal
                }, null, 8, ["noOfGarments", "noOfProductLine", "selectedReportPrintingOption", "onDownloadSingleGarmentReport", "onDownloadSingleGarmentReportWithQuantity", "onIsChecked", "onDownloadThreadUsageReport", "onNoOfGarments", "onNoOfProductionLines", "loadingGrid"]))
              : _createCommentVNode("", true),
            _createVNode(_component_OperationListComp, {
              ref: "operationListComp",
              isAddButtonDisabled: _ctx.isAddButtonDisabled,
              ticketTex: _ctx.ticketTex,
              onOverallStatus: _ctx.handleOperationStatus,
              onDisableReport: _cache[8] || (_cache[8] = ($event: any) => (_ctx.disableReportValue = $event)),
              onAllOperationStatusLength: _cache[9] || (_cache[9] = ($event: any) => (_ctx.allOperationStatusLength = $event)),
              onLoadingGridChanged: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadingGridVal = $event))
            }, null, 8, ["isAddButtonDisabled", "ticketTex", "onOverallStatus"])
          ]),
          _: 1
        }, 8, ["title", "onClose", "style"]))
      : _createCommentVNode("", true)
  ]))
}